<template>
  <div class="d-inline-block">
    <v-tooltip bottom v-if="iconButton">
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          icon
          v-on="on"
          x-small
          :disabled="disabled"
          @click.stop="showChangeOrderDialog"
        >
          <v-icon color="appMain" class="reorder-icon">swap_vert</v-icon>
        </v-btn>
      </template>
      <span>Change Campaigns Order</span>
    </v-tooltip>

    <v-btn
      v-else
      :disabled="disabled"
      color="appMain"
      @click.stop="showChangeOrderDialog"
    >
      Change Order
    </v-btn>

    <component
      v-if="isDialogOpen"
      :is="dialogComponent"
      v-model="isDialogOpen"
      :campaignId="campaignId"
      :campaignCategoryId="campaignCategoryId"
    />
  </div>
</template>

<script>
export default {
  name: 'CampaignChangeOrder',
  props: {
    campaignId: String,
    campaignCategoryId: String,
    iconButton: Boolean,
    disabled: Boolean,
  },
  data() {
    return {
      isDialogOpen: false,
    };
  },
  computed: {
    dialogComponent() {
      if (!this.isDialogOpen) return null;
      return () => import(`./CampaignChangeOrderDialog.vue`);
    },
  },
  methods: {
    showChangeOrderDialog() {
      this.isDialogOpen = true;
    },
  },
};
</script>

<style>
.reorder-icon {
  font-size: 22px !important;
}
</style>
